export const handleSmartTagOverlay = () => {
    if (document.querySelector( '[smart-tag-overlay]' ) !== null &&
          ( window?.SmartTag?.info?.version === '1.14.0' || window?.SmartTag?.info?.version === '1.14.1' ) ) {
            setTimeout(() => {
                    document.querySelector('[smart-tag-overlay]').style.top = '-10000px';
                },
                500
            );
     }
}